import type { Page } from '@aigc/types';
import { mutationOptions, queryOptions } from '@tanstack/react-query';
import qs from 'qs';
import { http } from '../common/http-client';
import type {
  TaskStatisticsInputDto,
  TaskStatisticsOutputDto,
  UpdateUserCreditInput,
  UserCreditItem,
  UserCreditsQueryInput,
} from './model';

/**
 * 更新用户信用点额度
 */
export const updateUserCredit = (accountName: string) =>
  mutationOptions({
    mutationKey: queryUserCredits.BASE_QUERY_KEY,
    mutationFn: (input: Omit<UpdateUserCreditInput, 'account_name'>) => {
      const json: UpdateUserCreditInput = {
        account_name: accountName,
        credit: input.credit,
      };

      return http.post('statistics/user/credit', {
        json,
      });
    },
  });

/**
 * 查询任务统计信息
 * @param start_time 开始时间戳（毫秒）
 * @param end_time 结束时间戳（毫秒）
 * @returns
 */
export function queryTaskStatistics(start_time: number, end_time: number) {
  return queryOptions({
    queryKey: [...queryTaskStatistics.BASE_QUERY_KEY, start_time, end_time],
    queryFn: () => {
      const input: TaskStatisticsInputDto = { start_time, end_time };
      return http
        .post('statistics', {
          json: input,
        })
        .json<TaskStatisticsOutputDto>();
    },
  });
}

queryTaskStatistics.BASE_QUERY_KEY = ['统计', '任务数量'];

/**
 * 查询当前用户的任务统计信息
 * @param start_time 开始时间戳（毫秒）
 * @param end_time 结束时间戳（毫秒）
 * @returns
 */
export function queryMyTaskStatistics(start_time: number, end_time: number) {
  return queryOptions({
    queryKey: [...queryMyTaskStatistics.BASE_QUERY_KEY, start_time, end_time],
    queryFn: () => {
      const input: TaskStatisticsInputDto = { start_time, end_time };
      return http
        .get('user/statistics', {
          searchParams: {
            start_time: input.start_time,
            end_time: input.end_time,
          },
        })
        .json<TaskStatisticsOutputDto>();
    },
  });
}

queryMyTaskStatistics.BASE_QUERY_KEY = ['统计', '个人任务数量'];

/**
 * 查询用户信用点额度
 * @param input 分页与搜索参数
 * @returns
 */
export function queryUserCredits(input: UserCreditsQueryInput) {
  return queryOptions({
    queryKey: [...queryUserCredits.BASE_QUERY_KEY, input],
    queryFn: () => {
      return http
        .post('statistics/users', {
          searchParams: qs.stringify(input.pagination),
          json: {
            ...(input.keyword ? { keyword: input.keyword } : {}),
          },
        })
        .json<Page<UserCreditItem>>();
    },
  });
}

queryUserCredits.BASE_QUERY_KEY = ['统计', '用户信用点额度'];
